import styled from 'styled-components';
import check from '../../assets/check.png';
import { pxToRem } from '../utils/ConvertUtils';

export const BTRadio = styled.input.attrs({ type: 'radio' })`
  appearance: none;
  width: ${pxToRem(44)};
  height: ${pxToRem(44)};
  border-radius: 50%;
  border: 2px solid #D9D9D9;
  background-color: white;
  cursor: pointer;
  position: relative;
  transition: border-color 0.2s;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #D9D9D9;
    transition: background-color 0.2s;
  }

  &:checked {
    border-color: #14B446;
  }

  &:checked::after {
    background-image: url(${check});
    background-color: #14B446;

    background-repeat: no-repeat;
    background-position: center;
    background-size: 60% 40%;
  }
`;
